import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@ui/Skeleton";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { CalculationsApi } from "@/api/CalculationsApi";
import { InfoCard, PriceCard, SummaryCard } from "@/components/Cards";
import SectionFetchError from "@/components/SectionFetchError";

export const SummaryCard4: FC = () => {
  const { t } = useTranslation();

  const { data, isPending, isError, refetch } = useQuery({
    queryKey: [QUERY_KEYS.PRICE],
    queryFn: CalculationsApi.getPrice,
  });

  return (
    <SummaryCard title={t("summary.card4")} dataTest="summary-card4">
      <div className="space-y-4">
        <p className="text-base font-bold" data-test="summary-card4-description">
          {t("summary.card4Description")}
        </p>
        {isError ? (
          <SectionFetchError refetch={() => void refetch()} className="h-[171px]" />
        ) : isPending ? (
          <Skeleton className="h-[171px] w-full" data-test="summary-price-skeleton" />
        ) : (
          <PriceCard price={data} dataTest="summary-price" />
        )}
        <InfoCard text={t("summary.card4Info")} className="bg-transparent" />
      </div>
    </SummaryCard>
  );
};
